goog.provide("shadow.js.shim.module$rehype_raw");
goog.provide("module$shadow_js_shim_module$rehype_raw");
shadow.js.shim.module$rehype_raw = shadow.js.nativeProvides["rehype-raw"] = shadow$bridge("rehype-raw");
module$shadow_js_shim_module$rehype_raw.default = shadow.js.shim.module$rehype_raw;
